import { render, staticRenderFns } from "./basic-samelocation-video.vue?vue&type=template&id=25566d79&scoped=true"
import script from "./basic-samelocation-video.vue?vue&type=script&lang=js"
export * from "./basic-samelocation-video.vue?vue&type=script&lang=js"
import style0 from "./basic-samelocation-video.vue?vue&type=style&index=0&id=25566d79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25566d79",
  null
  
)

export default component.exports